import { PageActionsButtonAddEntity } from '../../PageActionsButtonAddEntity'

function RequestCreateActionButton({
  Button = PageActionsButtonAddEntity,
  initialValues,
  onAction,
  ...buttonProps
}) {
  function handleButtonClick() {
    onAction?.({ initialValues })
  }

  return <Button {...buttonProps} onClick={handleButtonClick} />
}

export default RequestCreateActionButton
